import React, { useState, useEffect, useCallback, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const videos = [
  { id: 1, src: 'https://www.youtube.com/embed/5mKx3JZPqfs', label: 'Sanjeev Kadakol', role: 'SDE Intern' },
  { id: 2, src: 'https://www.youtube.com/embed/5aa9fScwW5s', label: 'Krishna Kumar', role: 'MERN Stack Developer Intern' },
  { id: 3, src: 'https://www.youtube.com/embed/Ew18B2o2uN8', label: 'Gautam Agrawal', role: 'Data Analytics Intern' },
  { id: 4, src: 'https://www.youtube.com/embed/ZUNBHE-D-A0', label: 'Om Prakash Raj', role: 'Web Developer Intern' },
  { id: 5, src: 'https://www.youtube.com/embed/cHPDGn7XZjA', label: 'Deepak Ravidas', role: 'Web Developer Intern' },
  { id: 6, src: 'https://www.youtube.com/embed/dVBpv8Ws_PY', label: 'Abhishek Kumar', role: 'Web Development Intern' },
  { id: 7, src: 'https://www.youtube.com/embed/RFoosWU1yN8', label: 'Prashant Kumar', role: 'Web Development Intern' },
  { id: 8, src: 'https://www.youtube.com/embed/YQcTuJVQQSg', label: 'Sahil Kumar', role: 'Web Development Intern' },
];

const getVideoId = (src) => src.split('/embed/')[1];

const VideoTestimonial = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLocked, setIsLocked] = useState(false);
  const touchStartRef = useRef(0);

  useEffect(() => {
    AOS.init({ offset: 200, duration: 1000 });
  }, []);

  const goTo = useCallback(
    (index) => {
      if (isLocked || index === activeIndex) return;
      setIsLocked(true);
      setActiveIndex(index);
      setTimeout(() => setIsLocked(false), 700);
    },
    [isLocked, activeIndex]
  );

  const goPrev = () => goTo(activeIndex === 0 ? videos.length - 1 : activeIndex - 1);
  const goNext = () => goTo(activeIndex === videos.length - 1 ? 0 : activeIndex + 1);

  // Touch swipe support
  const handleTouchStart = (e) => {
    touchStartRef.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e) => {
    const diff = touchStartRef.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? goNext() : goPrev();
    }
  };

  const getPosition = (index) => {
    const total = videos.length;
    const diff = ((index - activeIndex) % total + total) % total;
    if (diff === 0) return 'center';
    if (diff === 1) return 'right-1';
    if (diff === 2) return 'right-2';
    if (diff === total - 1) return 'left-1';
    if (diff === total - 2) return 'left-2';
    return 'hidden';
  };

  return (
    <>
      <section
        id="video-testimonial"
        className="vt-section"
      >
        {/* Background Ambient Glows */}
        <div className="vt-ambient vt-ambient-1"></div>
        <div className="vt-ambient vt-ambient-2"></div>
        <div className="vt-ambient vt-ambient-3"></div>

        <div className="container" data-aos="fade-up">
          {/* Header */}
          <div className="vt-header">
            <div className="vt-chip">🎬 Video Testimonials</div>
            <h2 className="vt-title">
              Real Stories. <span className="vt-accent">Real Results.</span>
            </h2>
            <p className="vt-subtitle">
              Don't just take our word for it — hear directly from our interns.
            </p>
          </div>

          {/* Carousel */}
          <div className="vt-carousel">
            <button className="vt-arrow vt-arrow-left" onClick={goPrev} aria-label="Previous">
              <FaChevronLeft />
            </button>

            <div
              className="vt-track"
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              {videos.map((video, index) => {
                const pos = getPosition(index);
                return (
                  <div
                    className={`vt-item vt-item--${pos}`}
                    key={video.id}
                    onClick={() => pos !== 'center' && goTo(index)}
                  >
                    <div className="vt-frame">
                      <div className="vt-frame-glow"></div>
                      <div className="vt-frame-border"></div>
                      <div className="vt-frame-inner">
                        <iframe
                          src={`${video.src}?rel=0&cc_load_policy=0&modestbranding=1&showinfo=0&iv_load_policy=3&controls=0`}
                          title={`Testimonial by ${video.label}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          className="vt-video"
                          loading="lazy"
                        ></iframe>
                        {pos !== 'center' && <div className="vt-overlay"></div>}
                      </div>
                    </div>
                    <div className="vt-info">
                      <span className="vt-name">{video.label}</span>
                      <span className="vt-role">{video.role}</span>
                    </div>
                  </div>
                );
              })}
            </div>

            <button className="vt-arrow vt-arrow-right" onClick={goNext} aria-label="Next">
              <FaChevronRight />
            </button>
          </div>

          {/* Filmstrip Thumbnail Navigation */}
          <div className="vt-filmstrip">
            {videos.map((video, i) => (
              <button
                key={video.id}
                className={`vt-thumb ${i === activeIndex ? 'vt-thumb--active' : ''}`}
                onClick={() => goTo(i)}
                aria-label={`Go to ${video.label}'s testimonial`}
              >
                <img
                  src={`https://img.youtube.com/vi/${getVideoId(video.src)}/0.jpg`}
                  alt={video.label}
                  className="vt-thumb-img"
                />
                <div className="vt-thumb-overlay">
                  <span className="vt-thumb-label">{video.label.split(' ')[0]}</span>
                </div>
                {i === activeIndex && (
                  <div key={activeIndex} className="vt-thumb-progress"></div>
                )}
              </button>
            ))}
          </div>

          {/* Slide Counter */}
          <div className="vt-counter">
            <span className="vt-counter-current">{String(activeIndex + 1).padStart(2, '0')}</span>
            <span className="vt-counter-sep">/</span>
            <span className="vt-counter-total">{String(videos.length).padStart(2, '0')}</span>
          </div>
        </div>
      </section>

      <style>{`
        /* ════════════════════════════════════════════════
           VIDEO TESTIMONIALS — CINEMATIC ARC CAROUSEL
           ════════════════════════════════════════════════ */

        .vt-section {
          padding: 100px 0 80px;
          background: #0a0118;
          color: #fff;
          position: relative;
          overflow: hidden;
        }

        /* ── Ambient Glow Orbs ── */
        .vt-ambient {
          position: absolute;
          border-radius: 50%;
          filter: blur(140px);
          opacity: 0.22;
          pointer-events: none;
        }
        .vt-ambient-1 {
          width: 500px; height: 500px;
          background: #7c3aed;
          top: -150px; left: -8%;
          animation: vtDrift 16s ease-in-out infinite alternate;
        }
        .vt-ambient-2 {
          width: 380px; height: 380px;
          background: #f59e0b;
          bottom: -120px; right: -5%;
          animation: vtDrift 12s ease-in-out infinite alternate-reverse;
        }
        .vt-ambient-3 {
          width: 280px; height: 280px;
          background: #6366f1;
          top: 50%; left: 50%;
          transform: translate(-50%, -50%);
          animation: vtPulse 8s ease-in-out infinite;
        }
        @keyframes vtDrift {
          from { transform: translate(0, 0) scale(1); }
          to   { transform: translate(40px, 50px) scale(1.18); }
        }
        @keyframes vtPulse {
          0%, 100% { opacity: 0.12; transform: translate(-50%, -50%) scale(1); }
          50%      { opacity: 0.28; transform: translate(-50%, -50%) scale(1.25); }
        }

        /* ── Header ── */
        .vt-header {
          text-align: center;
          position: relative;
          z-index: 2;
          margin-bottom: 55px;
        }
        .vt-chip {
          display: inline-block;
          padding: 8px 24px;
          background: rgba(124,58,237,0.1);
          border: 1px solid rgba(124,58,237,0.2);
          border-radius: 50px;
          font-size: 0.88rem;
          font-weight: 600;
          color: #a78bfa;
          margin-bottom: 22px;
          letter-spacing: 0.5px;
        }
        .vt-title {
          font-size: 3.2rem;
          font-weight: 900;
          line-height: 1.15;
          margin-bottom: 14px;
          letter-spacing: -1px;
        }
        .vt-accent {
          background: linear-gradient(135deg, #7c3aed, #f59e0b);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .vt-subtitle {
          font-size: 1.1rem;
          color: #6b7280;
          max-width: 460px;
          margin: 0 auto;
          line-height: 1.5;
        }

        /* ── Carousel Layout ── */
        .vt-carousel {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .vt-track {
          position: relative;
          width: 100%;
          max-width: 1000px;
          height: 580px;
          perspective: 1800px;
          perspective-origin: 50% 45%;
        }

        /* ── Slide Items ── */
        .vt-item {
          position: absolute;
          top: 50%; left: 50%;
          width: 270px;
          will-change: transform, opacity, filter;
          transition:
            transform 0.75s cubic-bezier(0.32, 0.72, 0, 1),
            opacity   0.75s cubic-bezier(0.32, 0.72, 0, 1),
            filter    0.75s cubic-bezier(0.32, 0.72, 0, 1);
        }

        /* ── 5-Card Positions ── */
        .vt-item--center {
          transform: translate(-50%, -50%) scale(1) rotateY(0deg);
          opacity: 1;
          filter: brightness(1);
          z-index: 10;
          cursor: default;
        }
        .vt-item--left-1 {
          transform: translate(-143%, -50%) scale(0.82) rotateY(6deg);
          opacity: 0.7;
          filter: brightness(0.5);
          z-index: 8;
          cursor: pointer;
        }
        .vt-item--left-2 {
          transform: translate(-210%, -52%) scale(0.65) rotateY(12deg);
          opacity: 0.35;
          filter: brightness(0.3);
          z-index: 6;
          cursor: pointer;
        }
        .vt-item--right-1 {
          transform: translate(43%, -50%) scale(0.82) rotateY(-6deg);
          opacity: 0.7;
          filter: brightness(0.5);
          z-index: 8;
          cursor: pointer;
        }
        .vt-item--right-2 {
          transform: translate(110%, -52%) scale(0.65) rotateY(-12deg);
          opacity: 0.35;
          filter: brightness(0.3);
          z-index: 6;
          cursor: pointer;
        }
        .vt-item--hidden {
          transform: translate(-50%, -50%) scale(0.4) rotateY(0deg);
          opacity: 0;
          pointer-events: none;
          z-index: 0;
        }

        /* Hover lift on side cards */
        .vt-item--left-1:hover,
        .vt-item--right-1:hover {
          filter: brightness(0.62);
          opacity: 0.8;
        }
        .vt-item--left-2:hover,
        .vt-item--right-2:hover {
          filter: brightness(0.4);
          opacity: 0.45;
        }

        /* ── Card Frame ── */
        .vt-frame {
          position: relative;
          border-radius: 20px;
          overflow: visible;
        }

        /* Glow behind active card */
        .vt-frame-glow {
          position: absolute;
          inset: -25px;
          border-radius: 32px;
          background: radial-gradient(circle, rgba(124,58,237,0.35) 0%, transparent 70%);
          opacity: 0;
          transition: opacity 0.75s ease;
          z-index: -2;
          filter: blur(25px);
        }
        .vt-item--center .vt-frame-glow {
          opacity: 1;
        }

        /* Animated gradient border */
        .vt-frame-border {
          position: absolute;
          inset: -3px;
          border-radius: 22px;
          background: linear-gradient(135deg, #7c3aed, #f59e0b, #6366f1, #7c3aed);
          background-size: 400% 400%;
          animation: vtShimmer 5s linear infinite;
          opacity: 0;
          transition: opacity 0.75s ease;
          z-index: -1;
        }
        .vt-item--center .vt-frame-border {
          opacity: 1;
        }
        @keyframes vtShimmer {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .vt-frame-inner {
          position: relative;
          background: #110827;
          border-radius: 18px;
          overflow: hidden;
        }

        /* ── Video Iframe ── */
        .vt-video {
          display: block;
          width: 100%;
          height: 480px;
          border: none;
        }

        /* Dark overlay on inactive slides */
        .vt-overlay {
          position: absolute;
          inset: 0;
          background: rgba(10, 1, 24, 0.5);
          z-index: 4;
          transition: background 0.4s ease;
          pointer-events: none;
        }

        /* ── Info Label ── */
        .vt-info {
          text-align: center;
          padding: 16px 0 0;
          transition: opacity 0.75s ease, transform 0.75s ease;
        }
        .vt-item--center .vt-info {
          opacity: 1;
          transform: translateY(0);
        }
        .vt-item:not(.vt-item--center) .vt-info {
          opacity: 0;
          transform: translateY(8px);
        }
        .vt-name {
          display: block;
          font-size: 1.08rem;
          font-weight: 700;
          color: #f0f0f0;
        }
        .vt-role {
          display: block;
          font-size: 0.82rem;
          color: #9ca3af;
          margin-top: 3px;
        }

        /* ── Navigation Arrows ── */
        .vt-arrow {
          position: relative;
          z-index: 20;
          width: 54px; height: 54px;
          border-radius: 50%;
          border: 1px solid rgba(255,255,255,0.08);
          background: rgba(255,255,255,0.03);
          backdrop-filter: blur(12px);
          color: #fff;
          font-size: 1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.35s ease;
        }
        .vt-arrow:hover {
          background: rgba(124,58,237,0.2);
          border-color: rgba(124,58,237,0.4);
          transform: scale(1.12);
          box-shadow: 0 0 25px rgba(124,58,237,0.25);
        }
        .vt-arrow:active {
          transform: scale(0.95);
        }

        /* ── Filmstrip Thumbnails ── */
        .vt-filmstrip {
          display: flex;
          justify-content: center;
          gap: 14px;
          margin-top: 40px;
          position: relative;
          z-index: 2;
        }

        .vt-thumb {
          position: relative;
          width: 56px; height: 56px;
          border-radius: 14px;
          border: 2px solid rgba(255,255,255,0.06);
          background: none;
          cursor: pointer;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.32, 0.72, 0, 1);
          padding: 0;
          flex-shrink: 0;
        }
        .vt-thumb--active {
          border-color: rgba(124,58,237,0.6);
          box-shadow: 0 0 22px rgba(124,58,237,0.3), 0 4px 14px rgba(0,0,0,0.3);
          transform: scale(1.15);
        }
        .vt-thumb:hover:not(.vt-thumb--active) {
          border-color: rgba(255,255,255,0.15);
          transform: scale(1.1);
        }
        .vt-thumb-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        .vt-thumb-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 55%);
          display: flex;
          align-items: flex-end;
          justify-content: center;
          padding-bottom: 5px;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .vt-thumb:hover .vt-thumb-overlay,
        .vt-thumb--active .vt-thumb-overlay {
          opacity: 1;
        }
        .vt-thumb-label {
          font-size: 0.52rem;
          font-weight: 700;
          color: #fff;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* Auto-rotate progress bar on active thumb */
        .vt-thumb-progress {
          position: absolute;
          bottom: 0;
          left: 0;
          height: 3px;
          background: linear-gradient(90deg, #7c3aed, #f59e0b);
          animation: vtProgress 5s linear forwards;
          border-radius: 0 0 12px 12px;
        }
        @keyframes vtProgress {
          from { width: 0; }
          to   { width: 100%; }
        }

        /* ── Slide Counter ── */
        .vt-counter {
          text-align: center;
          margin-top: 18px;
          font-size: 0.85rem;
          color: rgba(255,255,255,0.25);
          letter-spacing: 3px;
          position: relative;
          z-index: 2;
        }
        .vt-counter-current {
          color: #a78bfa;
          font-weight: 700;
          font-size: 1rem;
        }
        .vt-counter-sep {
          margin: 0 5px;
        }

        /* ═══════════════════════
           RESPONSIVE BREAKPOINTS
           ═══════════════════════ */

        @media (max-width: 1200px) {
          .vt-track { max-width: 860px; height: 560px; }
          .vt-item--left-2,
          .vt-item--right-2 { opacity: 0; pointer-events: none; }
        }

        @media (max-width: 992px) {
          .vt-track { max-width: 700px; height: 520px; }
          .vt-item { width: 250px; }
          .vt-video { height: 440px; }
          .vt-item--left-1  { transform: translate(-130%, -50%) scale(0.8) rotateY(5deg); }
          .vt-item--right-1 { transform: translate(30%, -50%) scale(0.8) rotateY(-5deg); }
          .vt-item--left-2,
          .vt-item--right-2 { opacity: 0; pointer-events: none; }
        }

        @media (max-width: 768px) {
          .vt-section { padding: 70px 0 50px; }
          .vt-title { font-size: 2.2rem; letter-spacing: -0.5px; }
          .vt-track { height: 480px; max-width: 500px; }
          .vt-item { width: 230px; }
          .vt-video { height: 400px; }
          .vt-item--left-1  { transform: translate(-115%, -50%) scale(0.75) rotateY(4deg); opacity: 0.4; }
          .vt-item--right-1 { transform: translate(15%, -50%) scale(0.75) rotateY(-4deg); opacity: 0.4; }
          .vt-item--left-2,
          .vt-item--right-2 { opacity: 0; pointer-events: none; }
          .vt-arrow { width: 42px; height: 42px; font-size: 0.85rem; }
          .vt-filmstrip { gap: 10px; }
          .vt-thumb { width: 44px; height: 44px; border-radius: 10px; }
        }

        @media (max-width: 480px) {
          .vt-section { padding: 50px 0 40px; }
          .vt-title { font-size: 1.8rem; }
          .vt-track { height: 420px; max-width: 320px; }
          .vt-item { width: 210px; }
          .vt-video { height: 370px; }
          .vt-item--left-1, .vt-item--right-1,
          .vt-item--left-2, .vt-item--right-2 { opacity: 0; pointer-events: none; }
          .vt-arrow { width: 38px; height: 38px; font-size: 0.78rem; }
          .vt-thumb { width: 38px; height: 38px; border-radius: 8px; }
          .vt-filmstrip { gap: 8px; }
        }
      `}</style>
    </>
  );
};

export default VideoTestimonial;
